const topBarConstantsEN = {
  dashboard: 'Dashboard',
  videos: 'Videos',
  categories: 'Categories',
  resources: 'Resources',
};

export default topBarConstantsEN;
